import { showNotification } from "@/entities/notification"
import { registerNotification } from "@/shared/api/websocket"
import { userCardsQueryOptions } from "../api/queries"

registerNotification("card_star", {
	handle: ({ notification_id, data }, ctx) => {
		showNotification({
			type: "silent",
			placement: null,
			origin: "server",
			notificationId: notification_id,
			name: "card_star",
		})
		const { queryKey } = userCardsQueryOptions(ctx.userId)
		ctx.queryClient.setQueryData(queryKey, (old) =>
			old?.map((card) => {
				if (card.id !== data.card_id) return card
				return { ...card, count_stars: data.star_count }
			}),
		)
		ctx.queryClient.invalidateQueries({ queryKey, refetchType: "none" })
	},
	// The same notification covers an ordinary card and an answer to the question
	// of the day; only the tab differs.
	route: ({ data }) => {
		if (data.feed_category === "qotd") {
			return { to: "/feed", search: { tab: "daily-question" as const } }
		}
		return { to: "/feed", search: { tab: "cards" as const } }
	},
	routePopup: null,
})
